var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFavouriteRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 29,
    viewBox: "0 0 32 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "remove-from-favourite-b",
    d: "M6.88717109,0 C9.06602159,0 11.1572172,1.01525886 12.5221293,2.61961853 L12.5221293,2.77586207 L10.5916527,5.55172414 L14,8.32758621 L10.5916527,11.5 L14,14.4376924 L10.5916527,17.0744719 L14,19.7237894 L12.5221293,23 L12.524,22.998 L12.5221293,23 L10.7064205,21.3455041 C4.25752395,15.4920981 0,11.6316076 0,6.89373297 C0,3.03324251 3.03035528,0 6.88717109,0 Z"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "remove-from-favourite-a",
    width: "200%",
    height: "160.9%",
    x: "-42.9%",
    y: "-21.7%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.131883741 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "remove-from-favourite-c",
    width: "171.4%",
    height: "143.5%",
    x: "-28.6%",
    y: "-13%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceAlpha",
    result: "shadowBlurInner1",
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic",
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowInnerInner1",
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.5 0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "remove-from-favourite-e",
    d: "M20.3285114,0 C24.064545,0 27,3.03324251 27,6.89373297 C27,11.6316076 22.875807,15.4920981 16.6288677,21.3580381 L14.8700207,23 L16.3016096,19.7237894 L13,17.0744719 L16.3016096,14.4376924 L13,11.5 L16.3016096,8.32758621 L13,5.55172414 L14.8700207,2.77586207 L14.8700207,2.61961853 L14.8700207,2.61961853 C16.1921884,1.01525886 18.217895,0 20.3285114,0 Z"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "remove-from-favourite-d",
    width: "200%",
    height: "160.9%",
    x: "-42.9%",
    y: "-21.7%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.131883741 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "remove-from-favourite-f",
    width: "171.4%",
    height: "143.5%",
    x: "-28.6%",
    y: "-13%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceAlpha",
    result: "shadowBlurInner1",
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic",
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowInnerInner1",
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.5 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    transform: "translate(1 2)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "currentColor",
    filter: "url(#remove-from-favourite-a)",
    xlinkHref: "#remove-from-favourite-b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "currentColor",
    xlinkHref: "#remove-from-favourite-b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "currentColor",
    filter: "url(#remove-from-favourite-c)",
    xlinkHref: "#remove-from-favourite-b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "currentColor",
    filter: "url(#remove-from-favourite-d)",
    xlinkHref: "#remove-from-favourite-e"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "currentColor",
    xlinkHref: "#remove-from-favourite-e"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "currentColor",
    filter: "url(#remove-from-favourite-f)",
    xlinkHref: "#remove-from-favourite-e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavouriteRemove);
export default __webpack_public_path__ + "static/media/favourite-remove.c09ce785.svg";
export { ForwardRef as ReactComponent };